import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.scss']
})
export class PopupModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  closeModal() {
    console.log("🛠️ 팝업 닫기 시도");
    this.activeModal.dismiss();  // ✅ `dismiss()`를 사용해야 정상적으로 닫힘
  }
}



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/shared/popup-modal/popup-modal.component.ts